import OneFree from "@components/Pages/OneFree/OneFree"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import One from "@jsons/oneFree.json"
import React from "react"

type Prodbo = {}

const overview = (prodbo: Prodbo) => {
	const pageData = getTranslatedPageData(One)
	const list = getValueOrThrow(pageData.AdvancedSideAsset)
	const hero = getValueOrThrow(pageData.heroData?.[0])
	const FAQ = getValueOrThrow(pageData.faqData)
	// const subMenu = getValueOrThrow(pageData.subMenu)

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath={"/products/one/free"}
			/>
			<OneFree list={list} hero={hero} faq={FAQ} />
		</>
	)
}

export default overview
